import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=47941cd8&scoped=true"
import script from "./Workspaces.vue?vue&type=script&lang=ts"
export * from "./Workspaces.vue?vue&type=script&lang=ts"
import style0 from "./Workspaces.vue?vue&type=style&index=0&id=47941cd8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47941cd8",
  null
  
)

export default component.exports